import store from '@/store/index'
import Vue from 'vue'
// import swal from 'sweetalert2'

function recursiveSearch (obj, tags = { h1: 0, h2: 0, h3: 0, h4: 0, h5: 0, h6: 0 }) {
  const headlineComponents = new Set(['ElHeadline', 'ElHeadlineV2', 'ElSubheadline', 'ElSubheadlineV2'])

  const walk = (node) => {
    if (Array.isArray(node)) {
      node.forEach(walk)
      return
    }

    if (node && typeof node === 'object') {
      if ('component' in node && headlineComponents.has(node.component)) {
        const tag = node?.options?.content?.description?.tag
        if (typeof tag === 'string' && Object.prototype.hasOwnProperty.call(tags, tag)) {
          tags[tag] += 1
        }
      }

      Object.keys(node).forEach(key => walk(node[key]))
    }
  }

  walk(obj)
  return tags
}

const validateInternalEmbedBlock = async (obj) => {
  const EMBED_COMPONENTS = new Set(['ElInternalEmbedBlock', 'ElEstageInternalEmbed'])

  const walk = async (node) => {
    if (Array.isArray(node)) {
      for (const item of node) {
        const ok = await walk(item)
        if (!ok.status) return ok
      }
      return {
        status: true
      }
    }

    if (node && typeof node === 'object') {
      if (EMBED_COMPONENTS.has(node.component)) {
        const hash = node?.options?.content?.code?.code
        if (hash) {
          const allowed = await store.dispatch('favorites/checkPaidBlock', {hash: hash})
          if (!allowed.status) {
            // await swal.fire({
            //   icon: 'warning',
            //   toast: true,
            //   position: 'top-start',
            //   title: 'This page is using an internal embed block that is not paid',
            //   timerProgressBar: true,
            //   showConfirmButton: false,
            //   timer: 5000
            // })
            return {
              icon: 'warning',
              title: 'Restricted Access!',
              error: 'This page contains licensed content (inside internal embed code) that is currently being used on another project/hub. Based on your license, you can only use this content on one hub.',
              status: false
            }
          }
        }
      }

      for (const key of Object.keys(node)) {
        const ok = await walk(node[key])
        if (!ok.status) return ok
      }
    }

    return {
      status: true
    }
  }

  return walk(obj)
}

export const criticalAudit = async (object) => {
  if (!object) {
    return {
      status: false
    }
  }

  const validEmbeds = await validateInternalEmbedBlock(object)
  if (!validEmbeds.status) {
    return validEmbeds
  }

  return {
    status: true
  }
}

export default function pageAudit (object) {
  if (!object) {
    return
  }

  let tags = recursiveSearch(object)
  let errorMessages = ''

  if (tags.h1 === 0) {
    errorMessages = 'This page does not contain a headline with an H1 tag. To help optimize the page for SEO and' +
      ' accessibility, add an H1 tag to the page title Headline element'
  }

  if (tags.h1 > 1) {
    errorMessages = 'This page has more than one heading with an H1 tag. To help optimize a page for SEO and' +
      ' accessibility, make sure the page title Headline element has an H1 tag and is the only one has tag H1 on that page.'
  }

  if (errorMessages) {
    Vue.swal.fire({
      icon: 'warning',
      toast: true,
      position: 'top-start',
      title: errorMessages,
      timerProgressBar: true,
      showConfirmButton: false,
      timer: 5000
    })
  }
}
